import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "@/lib/api";

// Minimal, self-contained embed view — no nav/footer, fixed compact layout.
// Used inside iframes pasted on third-party websites/blogs.
export default function MemorialEmbed() {
  const { slug } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    apiClient.get(`/memorials/${slug}`)
      .then(({ data }) => setM(data))
      .catch(() => setErr(true));
  }, [slug]);

  if (err) return <div style={{ padding: 24, fontFamily: "Georgia, serif", color: "#7A736E", textAlign: "center" }}>Memorial not found.</div>;
  if (!m) return <div style={{ padding: 24, fontFamily: "Georgia, serif", color: "#7A736E", textAlign: "center" }}>Loading…</div>;

  const bg = m.scenery_image_base64 ? `data:${m.scenery_mime_type || "image/jpeg"};base64,${m.scenery_image_base64}` : null;
  const portrait = m.pet_photo_base64 ? `data:${m.pet_photo_mime_type || "image/jpeg"};base64,${m.pet_photo_base64}` : null;
  const poemSnippet = (m.poem || "").split("\n").filter((l) => l.trim()).slice(0, 6).join("\n");
  const siteUrl = `${window.location.origin}/memorial/${m.share_slug}`;

  return (
    <div style={{
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      background: "#FDFBF7",
      minHeight: "100vh",
      padding: 16,
      boxSizing: "border-box",
    }}>
      <div style={{
        maxWidth: 420,
        margin: "0 auto",
        background: "#fff",
        border: "1px solid rgba(212,175,55,0.4)",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.9), 0 12px 32px -10px rgba(212,175,55,0.25)",
        overflow: "hidden",
      }}>
        {bg && (
          <div style={{ position: "relative", width: "100%", paddingBottom: "75%" }}>
            <img src={bg} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
            {portrait && (
              <div style={{
                position: "absolute", bottom: 12, right: 12,
                width: 64, height: 64, borderRadius: "50%", overflow: "hidden",
                border: "2px solid #fff",
                boxShadow: "0 0 0 2px #D4AF37",
              }}>
                <img src={portrait} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
            )}
          </div>
        )}
        <div style={{ padding: "24px 22px 22px", textAlign: "center" }}>
          <div style={{ color: "#D4AF37", letterSpacing: "0.28em", fontSize: 10, fontFamily: "Arial, sans-serif", textTransform: "uppercase", fontWeight: 500 }}>
            In Loving Memory
          </div>
          <div style={{ fontStyle: "italic", color: "#2C2825", fontSize: 30, marginTop: 8, lineHeight: 1 }}>
            {m.pet_name}
          </div>
          {m.dates && <div style={{ color: "#7A736E", fontStyle: "italic", fontSize: 13, marginTop: 4 }}>{m.dates}</div>}
          <div style={{ color: "#D4AF37", margin: "14px 0", fontSize: 12 }}>✦</div>
          {poemSnippet && (
            <div style={{ fontStyle: "italic", color: "#2C2825", fontSize: 14, lineHeight: 1.7, whiteSpace: "pre-line" }}>
              {poemSnippet}
            </div>
          )}
        </div>
        <div style={{
          padding: "10px 18px",
          borderTop: "1px solid rgba(212,175,55,0.25)",
          background: "rgba(242,227,198,0.18)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Arial, sans-serif",
        }}>
          <a href={siteUrl} target="_blank" rel="noopener noreferrer"
             style={{ color: "#D4AF37", fontSize: 10, letterSpacing: "0.22em", textTransform: "uppercase", textDecoration: "none", fontWeight: 500 }}>
            View full memorial →
          </a>
          <span style={{ color: "#7A736E", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase" }}>
            The Heirloom Pet
          </span>
        </div>
      </div>
    </div>
  );
}
